import React from 'react';

const services = [
  {
    id: 1,
    title: "Pune to Goa Cab",
    description:
      "Enjoy a comfortable and scenic road trip from Pune to Goa with Prince Cabs. Our experienced drivers ensure a safe and relaxing journey through the Konkan coast.",
    image: "/images/keyword/3.jpg",
  },
  {
    id: 2,
    title: "Pune to Bhimashankar Cab",
    description:
      "Book a Pune to Bhimashankar cab with Prince Cabs and visit the revered Jyotirlinga temple with ease. Ideal for pilgrims and nature lovers alike.",
    image: "/images/keyword/4.jpg",
  },
  {
    id: 3,
    title: "Pune to Mahabaleshwar Cab",
    description:
      "Escape to the hills with Prince Cabs’ Pune to Mahabaleshwar service. Experience cool weather, scenic views, and a smooth ride to this popular hill station.",
    image: "/images/keyword/1.jpg",
  },
  {
    id: 4,
    title: "Pune to Shirdi Cab",
    description:
      "Make your pilgrimage from Pune to Shirdi hassle-free with Prince Cabs. Comfortable vehicles and professional drivers for a peaceful journey to Sai Baba’s abode.",
    image: "/images/keyword/5.jpg",
  },
  {
    id: 5,
    title: "Pune to Mumbai Cabs",
    description:
      "Travel between Pune and Mumbai conveniently with Prince Cabs. Whether for business or leisure, we offer timely pickups and smooth rides across the expressway.",
    image: "/images/keyword/8.jpg",
  },
  {
    id: 6,
    title: "Pune to Imagica Cab",
    description:
      "Planning a fun day at Imagica? Let Prince Cabs take you from Pune to Imagica in comfort. Ideal for families, groups, and thrill-seekers heading to the amusement park.",
    image: "/images/keyword/13.jpg",
  },
];


const ServiceSection = () => {
  return (
   <>
    <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title">Services</h1>
            </div>
          </div>
        </div>
        <div className="inner-shape"></div>
      </section>
   
    <div className="service-page-section">
      <div className="container">
        <div className="row">
          {services.map((service) => (
            <div className="col-md-4" >
              <div className="service-content-wrap borderr">

                <figure className="service-img ">
                  <img src={service.image} alt={service.title} />
                </figure>
                <div className="service-content ">
                  <div className="service-header ">

                    <h3 className='darkcolor'>{service.title}</h3>
                  </div>
                  <p>{service.description}</p>
                </div>
                
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
   </>
  );
};

export default ServiceSection;
